import React, { useEffect, useRef, useState } from "react";
import sampleAudio from "../assets/audios/sample-audio.mp3";

const AudioPlay = ({
  volumeRange,
  setVolumeRange,
  pageNumber,
  pageType,
  audioPath,
  playTestSound,
  audioSeek,
  onAudioTime,
}) => {
  const [, setIsTestPlaying] = useState(false);
  const [testStarted, setTestStarted] = useState(false);
  const audioPlayer = useRef(null);
  useEffect(() => {
    if (!audioPlayer || testStarted) {
      return;
    }

    if (pageNumber === 2) {
      audioPlayer.current.src = sampleAudio;
    } else if (pageType === "Tests") {
      // 原本的條件是 pageNumber === 4——正常流程一定從第一頁進場，兩者等價。
      // 續考會直接回到當時那一頁（例如第 3 頁），寫死 4 音檔就不會開始播。
      const player = audioPlayer.current;
      player.src = audioPath;
      // 續考：接著上次播到的地方，不是從頭。要等 metadata 載完才設得動。
      if (audioSeek > 0) {
        const seek = () => {
          try {
            player.currentTime = audioSeek;
          } catch (e) {
            // 有些瀏覽器在還不能 seek 時會丟例外，那就從頭播，不要卡住考試
          }
        };
        player.addEventListener("loadedmetadata", seek, { once: true });
      }
      player.play();
      setTestStarted(true);
    } else if (pageType !== "Tests") {
      audioPlayer.current.pause();
    }
  }, [audioPath, audioSeek, pageNumber, pageType, testStarted]);

  useEffect(() => {
    setIsTestPlaying((pre) => {
      if (pre === playTestSound) {
        return pre;
      }

      if (playTestSound) {
        audioPlayer.current.play();
      } else {
        audioPlayer.current.pause();
      }
      return playTestSound;
    });
  }, [playTestSound]);

  const handleChange = (event) => {
    const newVolume = event.target.value;
    setVolumeRange(newVolume);
    audioPlayer.current.volume = newVolume;
  };

  return (
    <div className="audio-wrapper col col-12 col-md-5 text-center pt-2 pt-md-0">
      <div className="audio-container pb-2 pb-md-0">
        <img
          className="volume-icon height-control"
          src="/img/Speaker.svg"
          alt=""
        />
        <input
          className="slider"
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={volumeRange}
          onChange={handleChange}
        />
        <audio
          ref={audioPlayer}
          loop={pageNumber === 2}
          onTimeUpdate={
            onAudioTime ? (e) => onAudioTime(e.target.currentTime) : undefined
          }
        />
      </div>
    </div>
  );
};

export default AudioPlay;
